module.exports = __webpack_public_path__ + "static/vha-logo-55b16a1d0f801718aff5141c7dda49c4.png";